export default __webpack_public_path__ + "static/media/paypal.2a7be383.svg";